interface Props {
  size?: number;
}

export default function LinkIcon(props: Props) {
  const { size = 21 } = props;

  return (
    <svg
      width={size}
      height={size}
      css="flex-shrink: 0"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 21C16.299 21 21 16.299 21 10.5C21 4.70101 16.299 0 10.5 0C4.70101 0 0 4.70101 0 10.5C0 16.299 4.70101 21 10.5 21Z"
        fill="#375BD2"
      />
      <path
        d="M10.5 2.625L3.67999 6.5625V14.4375L10.5 18.375L17.32 14.4375V6.5625L10.5 2.625ZM14.4299 12.769L10.5 15.0378L6.57011 12.769V8.23095L10.5 5.96216L14.4299 8.23095V12.769Z"
        fill="white"
      />
    </svg>
  );
}
